import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getBankInfo } from '../../../api/system';

const useBankInfo = (options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>) => {
  return useQuery({
    queryKey: ['systemBankInfo'],
    queryFn: getBankInfo,
    ...options,
  });
};

export default useBankInfo;
